export default __webpack_public_path__ + "static/media/grade-white.05af8676.svg";